import { connect } from 'react-redux'
import createAction from 'loankeeper-common/helpers/createAction'

import {
  getOldGraphicByRestrDate,
  getShowCurrentGraphic,
  getActiveOldGraphicRestrDate,
  getLoadingStatus,
  isInstanceCreated,
} from './selectors'

import { actions } from './constants'

const mapStateToProps = (state, { ID }) => {
  const activeOldGraphicRestrDate = getActiveOldGraphicRestrDate(state, ID)

  return {
    isInstanceCreated: !!isInstanceCreated(state, ID),
    showCurrentGraphic: getShowCurrentGraphic(state, ID),
    oldGraphic: getOldGraphicByRestrDate(state, ID, activeOldGraphicRestrDate),
    loading: getLoadingStatus(state, ID),
  }
}

const mapDispatchToProps = (dispatch, { ID }) => ({
  initialize: ({ schedule }) => {
    dispatch(createAction(actions.INITIALIZE, {}, { ID }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
